// export const BASE_API_URL = "http://localhost:9909/admin";
export const BASE_API_URL = "https://rozimed-server.rozidrugs.in/admin";
